import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/translations-en.json';
import translationES from './locales/translations-es.json';
import translationRU from './locales/translations-ru.json';
import translationUA from './locales/translations-ua.json';

const resources = {
    en: { translation: translationEN },
    es: { translation: translationES },
    ru: { translation: translationRU },
    uk: { translation: translationUA },
} as const;

i18n.use(initReactI18next).init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false, // React already does escaping
    },
    react: {
        // hashTransKey: function (defaultValue) {
        //     // return a key based on defaultValue or if you prefer to just remind you should set a key return false and throw an error
        // },
        // defaultTransParent: 'div', // a valid react element - required before react 16
        // transEmptyNodeValue: '', // what to return for empty Trans
        transSupportBasicHtmlNodes: true, // allow <br/> and simple html elements in translations
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'em', 'i', 'b'],
        // transWrapTextNodes: '', // Wrap text nodes in a user-specified element.
        // i.e. set it to 'span'. By default, text nodes are not wrapped.
        // Can be used to work around a well-known Google Translate issue with React apps. See: https://github.com/facebook/react/issues/11538
        // (v11.10.0)
    },
});

export default i18n;
